import { Layout } from "../../../layouts/v1";
import { MainView } from "../../../views/return-exchange/search";
import { ProductOptionsContextProvider } from "../../../views/return-exchange/search/contexts/ProductOptionsContext";
import { ReturnExchangeArchivesContextProvider } from "../../../views/return-exchange/search/contexts/ReturnExchangeArchivesContext";
import { ReturnExchangesContextProvider } from "../../../views/return-exchange/search/contexts/ReturnExchangesContext";
import { SelectedReturnExchangesContextProvider } from "../../../views/return-exchange/search/contexts/SelectedReturnExchangesContext";
import { StoreInfosContextProvider } from "../../../views/return-exchange/search/contexts/StoreInfosContext";

export function ReturnExchange_SearchPage(props) {
    return (
        <>
            <StoreInfosContextProvider>
                <ReturnExchangeArchivesContextProvider>
                    <ReturnExchangesContextProvider>
                        <SelectedReturnExchangesContextProvider>
                            <ProductOptionsContextProvider>
                                <Layout>
                                    <MainView />
                                </Layout>
                            </ProductOptionsContextProvider>
                        </SelectedReturnExchangesContextProvider>
                    </ReturnExchangesContextProvider>
                </ReturnExchangeArchivesContextProvider>
            </StoreInfosContextProvider>
        </>
    );
}